
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 82.85 73.08"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M41.43 54C29 54 17.14 47.93 8.67 37.16 17.14 26.4 29 20.29 41.43 20.29s24.28 6.11 32.75 16.87C65.71 47.93 53.9 54 41.43 54zm40-18.89c-9.88-13.86-24.43-21.82-40-21.82s-30.11 8-40 21.85l-1.43 2 1.45 2C11.31 53.07 25.9 61 41.43 61s30.1-8 40-21.84l1.44-2zm-40 10a8 8 0 118-8 8 8 0 01-8 8zm0-22.91a15 15 0 1015 15 15 15 0 00-15-15z"}})])
          )
        }
      }
    